var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('span',{attrs:{"title":_vm.longDate(_vm.value)}},[_c('strong',[_vm._v(_vm._s(_vm.shortDate(_vm.value)))]),(_vm.timezone)?_c('span',{staticClass:"grey--text text--darken-1 ml-1",staticStyle:{"font-size":"0.75em"}},[_vm._v(_vm._s(_vm.timezoneLabel(_vm.value)))]):_vm._e()]):_c('span',[_vm._v("---")])
}
var staticRenderFns = []

export { render, staticRenderFns }